import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Result as ResultEnum } from "@chessalpha/core";
import { Box, IconButton, Stack } from "@mui/material";
import { Close } from "mdi-material-ui";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export const Result = ({ result, node, closeable, innerChildren, children, }) => {
    const { t } = useTranslation("Result");
    const [hide, setHide] = useState(false);
    // biome-ignore lint/correctness/useExhaustiveDependencies: Observer
    useEffect(() => {
        setHide(false);
    }, [result]);
    useEffect(() => {
        if (node && !node.next.length) {
            setHide(false);
        }
    }, [node]);
    if (hide ||
        (result !== ResultEnum.DRAW &&
            result !== ResultEnum.WHITEWIN &&
            result !== ResultEnum.BLACKWIN)) {
        return null;
    }
    return (_jsxs(Stack, { spacing: 1, sx: {
            fontSize: "60%",
            fontWeight: 700,
            textAlign: "center",
            "> div": {
                position: "relative",
                display: "inline-block",
                background: "#FFF",
                boxShadow: "rgba(0,0,0,0.12) 0 0.2vh 0.6vh, rgba(0,0,0,0.24) 0 0.2vh 0.4vh",
                borderRadius: "0.15em",
                padding: "0.3em 0.9em",
            },
        }, children: [_jsxs(Box, { sx: { whiteSpace: "nowrap" }, children: [t(`${result}`), innerChildren, closeable && (_jsx(IconButton, { "aria-label": "close", size: "small", sx: {
                            position: "absolute",
                            top: 0,
                            right: 0,
                            padding: "0.3em",
                            width: "0.2em",
                            height: "0.2em",
                            fontSize: "inherit",
                        }, onClick: () => {
                            setHide(true);
                        }, children: _jsx(Close, { sx: { fontSize: "0.6em" } }) }))] }), children] }));
};
//# sourceMappingURL=Result.js.map